module.exports = __webpack_public_path__ + "static/img/rank_254.fa1d906.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_254.png
// module id = ZkNv
// module chunks = 1